<!-- ==========================================================================
     ACESSO
     ========================================================================== -->
<p-dialog [(visible)]="telaUsuario.visivel" [modal]="true" [closable]="false"
          [showHeader]="false" [style]="estiloDialogo" styleClass="ag-dialog ag-dialog-acesso">
  <section class="acesso" *ngIf="telaUsuario.visivel">
    <div class="acesso-marca">
      <span class="acesso-selo">📌</span>
      <h1>Minha Agenda</h1>
      <p>Seus compromissos ficam vinculados ao par usuário + senha. Use sempre a mesma dupla para reencontrá-los.</p>
    </div>

    <label class="campo">
      <span class="campo-rotulo">Usuário</span>
      <input pInputText type="text" autocomplete="username" placeholder="Como você se identifica"
             [(ngModel)]="telaUsuario.nome" (keyup.enter)="entrar()">
    </label>

    <label class="campo">
      <span class="campo-rotulo">Senha</span>
      <input pInputText type="password" autocomplete="current-password" placeholder="Sua senha"
             [(ngModel)]="telaUsuario.senha" (keyup.enter)="entrar()">
    </label>

    <button type="button" class="btn-principal" (click)="entrar()">Entrar na agenda</button>

    <p class="acesso-nota">
      Não há cadastro nem recuperação: a combinação informada <em>é</em> a sua conta.
      Se for a primeira vez, a agenda começa vazia.
    </p>
  </section>
</p-dialog>


<!-- ==========================================================================
     APLICACAO
     ========================================================================== -->
<section class="agenda" *ngIf="usuario">

  <!-- ------------------------------------------------------------ cabeçalho -->
  <header class="topo">
    <div class="topo-id">
      <span class="topo-avatar">{{usuario.nome.charAt(0)}}</span>
      <div class="topo-txt">
        <span class="topo-ola">Agenda de</span>
        <strong class="topo-nome">{{usuario.nome}}</strong>
      </div>
    </div>

    <nav class="topo-acoes">
      <button type="button" class="btn-topo destaque" (click)="novoEvento()"
              pTooltip="Criar um novo compromisso" tooltipPosition="bottom">
        <i class="pi pi-plus"></i><span>Novo</span>
      </button>
      <button type="button" class="btn-topo" (click)="abrirCalendario()"
              pTooltip="Ver o calendário do ano inteiro" tooltipPosition="bottom">
        <i class="pi pi-calendar"></i><span>Calendário</span>
      </button>
      <button type="button" class="btn-topo" (click)="abrirCategorias()"
              pTooltip="Gerenciar suas categorias" tooltipPosition="bottom">
        <i class="pi pi-tags"></i><span>Categorias</span>
      </button>
      <button type="button" class="btn-topo discreto" (click)="logout()"
              pTooltip="Sair desta conta" tooltipPosition="bottom">
        <i class="pi pi-sign-out"></i><span>Sair</span>
      </button>
    </nav>
  </header>

  <!-- -------------------------------------------------------------- filtros -->
  <section class="painel-filtros" *ngIf="carregou && !contaNova">

    <div class="linha-filtro">
      <span class="filtro-titulo">Exibir</span>
      <div class="segmentado">
        <button type="button" [class.on]="escopo==='radar'" (click)="mudarEscopo('radar')">
          No radar <b>{{cont.radar}}</b>
        </button>
        <button type="button" [class.on]="escopo==='todos'" (click)="mudarEscopo('todos')">
          Todos <b>{{cont.todos}}</b>
        </button>
      </div>
    </div>

    <!-- busca: disponível apenas em "Todos" e acionada de forma explícita -->
    <div class="linha-filtro" *ngIf="escopo==='todos'">
      <span class="filtro-titulo">Busca</span>
      <div class="campo-busca">
        <div class="busca-campo">
          <i class="pi pi-search busca-lupa"></i>
          <input pInputText type="text" [(ngModel)]="busca" (keyup.enter)="buscar()"
                 placeholder="Palavra na descrição — opcional">
          <button type="button" class="busca-x" *ngIf="busca" (click)="limparBusca()" aria-label="Limpar busca">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <button type="button" class="busca-ok" (click)="buscar()">Buscar</button>
      </div>
    </div>

    <div class="linha-filtro">
      <span class="filtro-titulo">Período</span>
      <div class="chips">
        <button type="button" class="chip c-atrasado" [class.on]="fTempo.atrasado" (click)="alternarTempo('atrasado')">
          <i class="pi pi-exclamation-circle"></i> Vencidos <b>{{cont.atrasado}}</b>
        </button>
        <button type="button" class="chip c-hoje" [class.on]="fTempo.hoje" (click)="alternarTempo('hoje')">
          <i class="pi pi-clock"></i> Hoje <b>{{cont.hoje}}</b>
        </button>
        <button type="button" class="chip c-futuro" [class.on]="fTempo.futuro" (click)="alternarTempo('futuro')">
          <i class="pi pi-arrow-right"></i> Futuros <b>{{cont.futuro}}</b>
        </button>
      </div>
    </div>

    <div class="linha-filtro">
      <span class="filtro-titulo">Categoria</span>
      <div class="chips">
        <button type="button" class="chip c-cat" *ngFor="let cat of categorias; trackBy: porId"
                [class.on]="fCategorias[cat.id]" (click)="alternarCategoria(cat.id)">
          <span class="chip-escudo" [style.background-color]="cat.cor"><i>{{cat.icone}}</i></span>
          {{cat.descricao}} <b>{{contCat[cat.id] || 0}}</b>
        </button>
        <button type="button" class="chip c-cat" *ngIf="contSemCat || fCategorias[0]"
                [class.on]="fCategorias[0]" (click)="alternarCategoria(0)">
          <span class="chip-escudo neutro"><i>◽</i></span>
          Sem categoria <b>{{contSemCat}}</b>
        </button>
      </div>
    </div>

    <div class="linha-filtro sumario">
      <span class="resultado">
        <i class="pi pi-spin pi-spinner" *ngIf="atualizando"></i>
        <strong>{{visiveis.length}}</strong> compromisso(s) em exibição
        <em class="token-busca" *ngIf="buscaAtiva">“{{buscaAtiva}}”</em>
      </span>
      <button type="button" class="btn-limpar" *ngIf="temFiltro" (click)="limparFiltros()">
        <i class="pi pi-times"></i> Limpar filtros
      </button>
    </div>
  </section>

  <!-- -------------------------------------------------------- estado vazio -->
  <section class="vazio" *ngIf="carregou && !visiveis.length">
    <div class="vazio-postit">
      <span class="vazio-icone">{{iconeVazio}}</span>
      <h2>{{rotuloVazio}}</h2>
      <p>{{detalheVazio}}</p>
      <button type="button" class="btn-principal" *ngIf="!temFiltro" (click)="novoEvento()">
        <i class="pi pi-plus"></i> Criar compromisso
      </button>
      <button type="button" class="btn-principal" *ngIf="temFiltro" (click)="limparFiltros()">
        <i class="pi pi-times"></i> Limpar filtros
      </button>
    </div>
  </section>

  <!-- ----------------------------------------------------- quadro de post-its -->
  <section class="quadro" [class.ocupado]="atualizando" *ngIf="visiveis.length">
    <div class="slot" *ngFor="let co of visiveis" [style.animation-delay]="co._delay">
      <div class="tilt" [ngClass]="co._giro">
        <article [ngClass]="co._cls">

          <span class="fita" [style.background-color]="co._fita"></span>

          <div class="escudo" [style.background-color]="co._catCor"
               [pTooltip]="co._catNome" tooltipPosition="left">
            <i>{{co._catIcone}}</i>
          </div>

          <div class="postit-topo">
            <div class="data-bloco" [attr.aria-label]="co._acessivel">
              <span class="data-dia">{{co._dia}}</span>
              <span class="data-resto">
                <span class="data-mes">{{co._mesExt}}</span>
                <span class="data-ano">{{co._ano}} · {{co._semana}}</span>
              </span>
            </div>
            <span class="carimbo">{{co._selo}}</span>
          </div>

          <p class="postit-msg">{{co.descricao}}</p>

          <div class="postit-rodape">
            <span class="postit-cat">{{co._catNome}}</span>
            <div class="acoes">
              <button type="button" class="acao ok" (click)="concluir(co)"
                      pTooltip="Concluir" tooltipPosition="top" aria-label="Concluir compromisso">
                <i class="pi pi-check"></i>
              </button>
              <button type="button" class="acao" (click)="editar(co)"
                      pTooltip="Editar" tooltipPosition="top" aria-label="Editar compromisso">
                <i class="pi pi-pencil"></i>
              </button>
              <button type="button" class="acao" (click)="reagendar(co)"
                      pTooltip="Reagendar" tooltipPosition="top" aria-label="Reagendar compromisso">
                <i class="pi pi-calendar-plus"></i>
              </button>
              <button type="button" class="acao" (click)="clonar(co)"
                      pTooltip="Clonar" tooltipPosition="top" aria-label="Clonar compromisso">
                <i class="pi pi-copy"></i>
              </button>
              <button type="button" class="acao perigo" (click)="excluir(co)"
                      pTooltip="Excluir" tooltipPosition="top" aria-label="Excluir compromisso">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </div>

        </article>
      </div>
    </div>
  </section>
</section>


<!-- ==========================================================================
     COMPROMISSO — criar / editar
     ========================================================================== -->
<p-dialog [(visible)]="evento.visivel" [modal]="true" [showHeader]="false"
          [style]="estiloDialogoLargo" styleClass="ag-dialog ag-dialog-evento">
  <section class="form-luxo" *ngIf="evento.visivel">

    <header class="form-topo">
      <div>
        <span class="form-eyebrow">Compromisso</span>
        <h2>{{evento.titulo}}</h2>
      </div>
      <button type="button" class="btn-fechar" (click)="evento.visivel=false" aria-label="Fechar">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="form-corpo">

      <!-- pré-visualização ao vivo -->
      <aside class="form-previa" *ngIf="previa">
        <span class="previa-rotulo">Pré-visualização</span>
        <div class="tilt g2">
          <article [ngClass]="previa._cls">
            <span class="fita" [style.background-color]="previa._fita"></span>
            <div class="escudo" [style.background-color]="previa._catCor"><i>{{previa._catIcone}}</i></div>
            <div class="postit-topo">
              <div class="data-bloco">
                <span class="data-dia">{{previa._dia}}</span>
                <span class="data-resto">
                  <span class="data-mes">{{previa._mesExt}}</span>
                  <span class="data-ano">{{previa._ano}} · {{previa._semana}}</span>
                </span>
              </div>
              <span class="carimbo">{{previa._selo}}</span>
            </div>
            <p class="postit-msg" [class.fantasma]="previa._vazia">{{previa.descricao}}</p>
            <div class="postit-rodape">
              <span class="postit-cat">{{previa._catNome}}</span>
            </div>
          </article>
        </div>
      </aside>

      <!-- campos -->
      <div class="form-campos">

        <label class="campo">
          <span class="campo-rotulo">Descrição <em>obrigatório</em></span>
          <textarea pInputText rows="3" maxlength="500" placeholder="O que precisa ser feito?"
                    [(ngModel)]="evento.descricao" (ngModelChange)="atualizarPrevia()"></textarea>
        </label>

        <div class="campo">
          <span class="campo-rotulo">Categoria</span>
          <div class="grade-cat">
            <button type="button" class="opcao-cat" *ngFor="let cat of categorias; trackBy: porId"
                    [class.on]="evento.idCategoria==cat.id" (click)="escolherCategoriaEvento(cat.id)">
              <span class="escudo pequeno" [style.background-color]="cat.cor"><i>{{cat.icone}}</i></span>
              <span class="opcao-cat-nome">{{cat.descricao}}</span>
            </button>
            <button type="button" class="opcao-cat nova" (click)="abrirCategorias()">
              <span class="escudo pequeno neutro"><i>＋</i></span>
              <span class="opcao-cat-nome">Gerenciar</span>
            </button>
          </div>
        </div>

        <div class="campo">
          <span class="campo-rotulo">Data de vencimento</span>
          <input pInputText type="date" [(ngModel)]="evento.dia" (ngModelChange)="atualizarPrevia()">
          <div class="atalhos">
            <button type="button" (click)="adiarPara(0)">Hoje</button>
            <button type="button" (click)="adiarPara(1)">Amanhã</button>
            <button type="button" (click)="adiarPara(7)">+7 dias</button>
            <button type="button" (click)="adiarPara(30)">+30 dias</button>
          </div>
        </div>

        <div class="campo">
          <span class="campo-rotulo">Avisar com antecedência de</span>
          <div class="atalhos aviso">
            <button type="button" *ngFor="let a of AVISOS_RAPIDOS; trackBy: porIndice"
                    [class.on]="evento.aviso==a" (click)="escolherAviso(a)">{{a}}d</button>
            <input pInputText pKeyFilter="int" class="aviso-custom" placeholder="outro"
                   [(ngModel)]="evento.aviso" (ngModelChange)="atualizarPrevia()">
          </div>
          <span class="campo-dica">O compromisso entra no radar da tela inicial a partir daí.</span>
        </div>

      </div>
    </div>

    <footer class="form-rodape">
      <button type="button" class="btn-secundario" (click)="evento.visivel=false">Cancelar</button>
      <button type="button" class="btn-principal" (click)="salvarEvento()">
        <i class="pi pi-check"></i> {{evento.acao}}
      </button>
    </footer>
  </section>
</p-dialog>


<!-- ==========================================================================
     REAGENDAMENTO
     ========================================================================== -->
<p-dialog [(visible)]="telaReaj.visivel" [modal]="true" [showHeader]="false"
          [style]="estiloDialogo" styleClass="ag-dialog">
  <section class="form-luxo compacto" *ngIf="telaReaj.visivel">
    <header class="form-topo">
      <div>
        <span class="form-eyebrow">Reagendar</span>
        <h2>Nova data</h2>
      </div>
      <button type="button" class="btn-fechar" (click)="telaReaj.visivel=false" aria-label="Fechar">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="form-campos">
      <div class="citacao">{{telaReaj.compromisso.descricao}}</div>

      <label class="campo">
        <span class="campo-rotulo">Data de vencimento</span>
        <input pInputText type="date" [(ngModel)]="telaReaj.dia">
      </label>
      <div class="atalhos">
        <button type="button" (click)="adiarReagendamento(1)">Amanhã</button>
        <button type="button" (click)="adiarReagendamento(7)">+7 dias</button>
        <button type="button" (click)="adiarReagendamento(15)">+15 dias</button>
        <button type="button" (click)="adiarReagendamento(30)">+30 dias</button>
      </div>

      <label class="campo">
        <span class="campo-rotulo">Avisar com x dias</span>
        <input pInputText pKeyFilter="int" [(ngModel)]="telaReaj.aviso">
      </label>
    </div>

    <footer class="form-rodape">
      <button type="button" class="btn-secundario" (click)="telaReaj.visivel=false">Cancelar</button>
      <button type="button" class="btn-principal" (click)="reagendarCompromisso()">
        <i class="pi pi-check"></i> Reagendar
      </button>
    </footer>
  </section>
</p-dialog>


<!-- ==========================================================================
     CATEGORIAS — CRUD
     ========================================================================== -->
<p-dialog [(visible)]="telaCategorias.visivel" [modal]="true" [showHeader]="false"
          [style]="estiloDialogo" styleClass="ag-dialog">
  <section class="form-luxo" *ngIf="telaCategorias.visivel">
    <header class="form-topo">
      <div>
        <span class="form-eyebrow">Organização</span>
        <h2>Categorias</h2>
      </div>
      <button type="button" class="btn-fechar" (click)="telaCategorias.visivel=false" aria-label="Fechar">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="form-campos">
      <ul class="lista-cat">
        <li *ngFor="let cat of categorias; trackBy: porId">
          <span class="escudo" [style.background-color]="cat.cor"><i>{{cat.icone}}</i></span>
          <div class="lista-cat-txt">
            <strong>{{cat.descricao}}</strong>
            <span>{{contCat[cat.id] || 0}} compromisso(s)</span>
          </div>
          <button type="button" class="acao" (click)="editarCategoria(cat)"
                  pTooltip="Editar" tooltipPosition="top" aria-label="Editar categoria">
            <i class="pi pi-pencil"></i>
          </button>
          <button type="button" class="acao perigo" (click)="excluirCategoriaConfirm(cat)"
                  pTooltip="Excluir" tooltipPosition="top" aria-label="Excluir categoria">
            <i class="pi pi-trash"></i>
          </button>
        </li>
      </ul>
      <p class="campo-dica" *ngIf="!categorias.length">Nenhuma categoria ainda. Crie a primeira abaixo.</p>
    </div>

    <footer class="form-rodape">
      <button type="button" class="btn-principal" (click)="novaCategoria()">
        <i class="pi pi-plus"></i> Nova categoria
      </button>
    </footer>
  </section>
</p-dialog>

<p-dialog [(visible)]="formCat.visivel" [modal]="true" [showHeader]="false"
          [style]="estiloDialogo" styleClass="ag-dialog" [baseZIndex]="10050">
  <section class="form-luxo compacto" *ngIf="formCat.visivel">
    <header class="form-topo">
      <div>
        <span class="form-eyebrow">Categoria</span>
        <h2>{{formCat.titulo}}</h2>
      </div>
      <button type="button" class="btn-fechar" (click)="formCat.visivel=false" aria-label="Fechar">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="form-campos">
      <div class="previa-cat">
        <span class="escudo grande" [style.background-color]="formCat.cor"><i>{{formCat.icone}}</i></span>
        <span class="previa-cat-nome">{{formCat.descricao || 'Nome da categoria'}}</span>
      </div>

      <label class="campo">
        <span class="campo-rotulo">Descrição <em>obrigatório</em></span>
        <input pInputText type="text" maxlength="60" placeholder="Ex.: Jurídico, Contratos, Pessoal"
               [(ngModel)]="formCat.descricao">
      </label>

      <div class="campo">
        <span class="campo-rotulo">Ícone</span>
        <button type="button" class="btn-emoji" (click)="abrirEmojis()">
          <span>{{formCat.icone}}</span> Escolher emoji
        </button>
      </div>

      <div class="campo">
        <span class="campo-rotulo">Cor</span>
        <div class="paleta">
          <button type="button" class="swatch" *ngFor="let c of CORES_RAPIDAS; trackBy: porIndice"
                  [style.background-color]="c" [class.on]="formCat.cor==c"
                  (click)="escolherCorCategoria(c)" [attr.aria-label]="c"></button>
          <p-colorPicker [(ngModel)]="formCat.cor"></p-colorPicker>
        </div>
      </div>
    </div>

    <footer class="form-rodape">
      <button type="button" class="btn-secundario" (click)="formCat.visivel=false">Cancelar</button>
      <button type="button" class="btn-principal" (click)="salvarCategoria()">
        <i class="pi pi-check"></i> Salvar
      </button>
    </footer>
  </section>
</p-dialog>

<p-dialog [(visible)]="seletorEmoji.visivel" [modal]="true" [showHeader]="false"
          [style]="estiloDialogo" styleClass="ag-dialog" [baseZIndex]="10100">
  <section class="form-luxo compacto" *ngIf="seletorEmoji.visivel">
    <header class="form-topo">
      <div>
        <span class="form-eyebrow">Ícone</span>
        <h2>Escolha um emoji</h2>
      </div>
      <button type="button" class="btn-fechar" (click)="seletorEmoji.visivel=false" aria-label="Fechar">
        <i class="pi pi-times"></i>
      </button>
    </header>

    <div class="emoji-corpo">
      <div class="emoji-grupo" *ngFor="let g of EMOJIS; trackBy: porIndice">
        <span class="emoji-titulo">{{g.grupo}}</span>
        <div class="emoji-grade">
          <button type="button" *ngFor="let e of g.itens; trackBy: porIndice"
                  [class.on]="formCat.icone==e" (click)="escolherEmoji(e)">{{e}}</button>
        </div>
      </div>
    </div>
  </section>
</p-dialog>


<!-- ==========================================================================
     CALENDARIO DO ANO
     ========================================================================== -->
<section class="calendario" *ngIf="calendario.visivel">
  <header class="cal-topo">
    <div class="cal-nav">
      <button type="button" class="cal-seta" (click)="anoAnterior()" aria-label="Ano anterior">
        <i class="pi pi-chevron-left"></i>
      </button>
      <h2>{{calendario.ano}}</h2>
      <button type="button" class="cal-seta" (click)="anoSeguinte()" aria-label="Próximo ano">
        <i class="pi pi-chevron-right"></i>
      </button>
      <button type="button" class="cal-hoje" (click)="anoAtual()">Hoje</button>
    </div>

    <div class="cal-legenda">
      <span><i class="pt t-atrasado"></i> Vencido</span>
      <span><i class="pt t-hoje"></i> Hoje</span>
      <span><i class="pt t-futuro"></i> Futuro</span>
    </div>

    <button type="button" class="btn-fechar" (click)="fecharCalendario()" aria-label="Fechar calendário">
      <i class="pi pi-times"></i>
    </button>
  </header>

  <div class="cal-corpo">
    <p class="cal-vazio" *ngIf="calendario.vazio">
      Nenhum compromisso registrado em {{calendario.ano}}.
    </p>

    <div class="cal-grade">
      <section [ngClass]="m.cls" *ngFor="let m of calendario.meses; trackBy: porIndice">
        <header class="mes-topo">
          <h3>{{m.nome}}</h3>
          <span>{{m.resumo}}</span>
        </header>
        <div class="mes-semana">
          <span *ngFor="let d of SEMANA_MINI; trackBy: porIndice">{{d}}</span>
        </div>
        <div class="mes-dias">
          <button type="button" *ngFor="let c of m.celulas; trackBy: porIndice"
                  [ngClass]="c.cls" [disabled]="!c.clicavel"
                  [attr.title]="c.titulo" (click)="abrirDia(c)">
            <span class="cel-n">{{c.n}}</span>
            <span class="cel-pontos">
              <i *ngFor="let p of c.pontos; trackBy: porIndice" class="pt"
                 [class.feito]="p.feito" [style.background-color]="p.cor"></i>
              <em *ngIf="c.extra">{{c.extra}}</em>
            </span>
          </button>
        </div>
      </section>
    </div>
  </div>

  <!-- overlay do dia, dentro da viewport, apenas leitura -->
  <div class="dia-overlay" *ngIf="diaAberto" (click)="fecharDia()">
    <article class="dia-card" (click)="$event.stopPropagation()">
      <header class="dia-topo">
        <h3>{{diaAberto.titulo}}</h3>
        <button type="button" class="btn-fechar" (click)="fecharDia()" aria-label="Fechar">
          <i class="pi pi-times"></i>
        </button>
      </header>
      <ul class="dia-lista">
        <li *ngFor="let ev of diaAberto.itens; trackBy: porId" [ngClass]="ev._clsLista">
          <span class="escudo" [style.background-color]="ev._catCor"><i>{{ev._catIcone}}</i></span>
          <div class="ev-txt">
            <p class="ev-msg">{{ev.descricao}}</p>
            <span class="ev-meta">
              <b [ngClass]="'st-' + ev._estado">{{ev._concluido ? 'CONCLUÍDO' : ev._selo}}</b>
              · {{ev._catNome}}
            </span>
          </div>
        </li>
      </ul>
      <p class="dia-nota">Visualização apenas. Feche o calendário para editar.</p>
    </article>
  </div>
</section>

<p-confirmDialog header="Confirmação" key="agenda" icon="pi pi-exclamation-triangle"
                 styleClass="ag-confirm"></p-confirmDialog>
